import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import Castle from '../../template/HomeworkNew/Castle';
import StepChange from '../../template/HomeworkNew/StepChange';
import { COURSE_URL, ROUND_NAME } from "../../constants";
import Teach from '../../template/HomeworkNew/Teach';
import ProgressBar from '../../template/HomeworkNew/ProgressBar';
import CloseIcon from '../../template/HomeworkNew/CloseIcon';
import Load from '../../template/Load/Load';
import { parseQuery, myStorage } from '../../utils/tools';
import clientApi from '../../api/client';
import {apiDefine} from '../../api/web';

class CastlePage extends Component {
    constructor(props){
        super(props);
        this.storage = myStorage;
        this.queryObj = parseQuery(window.location.search.slice(1));
        this.questionList = [];
        this.state = {
            showStepChange: true,
            currentIndex: Number(props.match.params.index) - 1,
            totalIndex: NaN,
            level0: this.queryObj.castletype === '3' || this.queryObj.castletype === 3,
            teach: true,
            device: JSON.parse(this.storage.getItem('panda_client_data')).device
        };
        this.timeOutArr = [];
    }
    componentDidMount(){
        const { currentIndex, level0 } = this.state;
        apiDefine({apiName:'alertViewBack',fn:this.alertViewBack}); // 定义弹框回调方法
        let curRoundIndex, _questionList;
        try {
            _questionList = JSON.parse(this.storage.getItem('panda_homework_questioninfo'));
            this.sort = JSON.parse(this.storage.getItem('panda_homework_sort'));
        } catch (error) {
            clientApi.alertView({
                content: '作业异常，请重新开始',
                confirm: '确认',
                id:'H5_1005'
            });
            console.log(error)
        }
        curRoundIndex = level0 ? this.sort.indexOf(3) : this.sort.indexOf(4);
        this.questionList = _questionList[curRoundIndex];
        this.storage.setItem('panda_homework_next',curRoundIndex + 1);
        this.setState({
            completeRender: true,
            questionInfo:this.questionList[currentIndex],
            totalIndex: this.questionList.length - 1
        });
        this.timeOutArr.push(
            setTimeout(() => {
                this.stepChangeRef.cloudPlay(()=>{
                    this.timeOutArr.push(
                        setTimeout(() => {
                            this.setState({
                                showStepChange: false,
                                stepChange: 'out'
                            })
                        }, 1200)
                    );
                });
            }, 400)
        )
    }
    componentWillUnmount(){
        this.timeOutArr.map(ele => (clearTimeout(ele)))
    }
    alertViewBack = () => {
        clientApi.closeH5Page({reason: 'homeworkError'})
    }
    nextQuestion = (score) => {
        const { currentIndex, totalIndex, level0 } = this.state;
        if(currentIndex + 1 > totalIndex){
            this.setState({
                showStepChange: true,
            });
            setTimeout(() => {
                this.stepChangeRef.cloudPlay();
            }, 0);
            const nextIndex = this.storage.getItem('panda_homework_next');
            const nextRound = ROUND_NAME[this.sort[Number(nextIndex)]];
            const nextPath = nextRound? `${nextRound}/1` : `result`
            const { history } = this.props;
            setTimeout(() => {
                history.push({
                    pathname: `${COURSE_URL}/homework/${nextPath}`,
                    search: `${window.location.search}`,
                })
            },1000)
        }
        else{
            this.child.restart();
            this.child.child.setStep('step1')
            this.setState({
                currentIndex: currentIndex + 1,
                questionInfo: this.questionList[currentIndex + 1]
            })
            const { history } = this.props;
            history.push({
                pathname: `${COURSE_URL}/homework/castle/${currentIndex + 2}`,
                search: `${window.location.search}`,
            });
            if(level0){
                this.setState({teach: true});
            }
        }
    }

    teachComplete = () => {
        this.setState({teach:false})
    }

    hideLoad = () => {
        this.setState({showLoad:false});
    }
    showLoad = () => {
        this.setState({showLoad:true});
    }

    render(){
        const { 
            completeRender,
            showLoad,
            stepChange, 
            showStepChange, 
            currentIndex, 
            totalIndex,
            teach,
            level0,
            questionInfo,
            device
         } = this.state;
        const { classschid } = this.queryObj;
        return(
            <DocumentTitle title={'课后作业'}>
                <React.Fragment>
                    {completeRender && 
                        <div>
                            <CloseIcon closeReason="homeworkBreak" />
                            <ProgressBar currentNum={currentIndex + 1} totalNum={totalIndex + 1} />
                            {(teach && level0)?
                                <Teach teachComplete={this.teachComplete} questionInfo={questionInfo} />
                                :
                                <Castle 
                                    device={device}
                                    classSchId={classschid}
                                    level0={level0}
                                    questionInfo={questionInfo}
                                    currentIndex={currentIndex}
                                    totalIndex={totalIndex}
                                    nextQuestion={this.nextQuestion}
                                    completeRenderFun={this.hideLoad}
                                    ref={com => this.child = com}
                                />
                            }
                        </div>
                    }
                    {!!showStepChange && 
                        <StepChange status={stepChange || 'in'} ref={com => this.stepChangeRef = com} />
                    }
                    {showLoad && 
                        <Load />
                    }
                </React.Fragment>
            </DocumentTitle>
        )
    }
}

export default CastlePage;



// WEBPACK FOOTER //
// ./src/components/homeworkNewPage/CastlePage.jsx